import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenesysCloudPlatformApiService } from '../../../common/services/genesys-cloud-platform-api.service';
import { Configuration } from '../models/configuration.model';

@Injectable({
  providedIn: 'root'
})
export class WebDeploymentsApiService {
  static readonly WebDeploymentsPath = 'api/v2/webdeployments';

  constructor(readonly api: GenesysCloudPlatformApiService) {
  }

  configurations$(deploymentId: string): Observable<Configuration> {
    const path = `${WebDeploymentsApiService.WebDeploymentsPath}/deployments/${deploymentId}/configurations`;
    return this.api.get$(path);
  }
}
